import { createAppSelector } from 'store/hooks';

export const tabLayoutNavigationSelector = createAppSelector(
  [
    (state) => state.general.tabLayout.activeTab,
    (state) => state.general.tabLayout.titles
  ],
  (activeTab, titles) => {
    return { activeTab, titles };
  }
);

export const tabLayoutSelector = createAppSelector(
  [(state) => state.general.tabLayout.titles],
  (titles) => {
    return titles;
  }
);

export const tabLayoutBodySelector = createAppSelector(
  [(state) => state.general.tabLayout.activeTab],
  (activeTab) => {
    return activeTab;
  }
);

export const apiRateLimitSelector = createAppSelector(
  [(state) => state.general.apiRateLimitedUntil],
  (apiRateLimitedUntil) => {
    return { apiRateLimitedUntil };
  }
);

export const hasDataLoadFailedSelector = createAppSelector(
  [(state) => state.general.hasDataLoadFailed],
  (hasDataLoadFailed) => {
    return { hasDataLoadFailed };
  }
);

export const isOfflineSelector = createAppSelector(
  [(state) => state.general.isOffline],
  (isOffline) => {
    return { isOffline };
  }
);
